export default class UserForPasswordRecoveryNotFound extends Error {
  constructor() {
    super()
    Object.setPrototypeOf(this, UserForPasswordRecoveryNotFound.prototype)
  }
}
